<template>
  <div id="classDetailsDiv">
    <div class="">
      <!--   <div v-if="classStatus !='-1'" class="head_title class_head_title">
        <div v-if="classStatus !='-1'" class="head_title_font class_head_title_font">
          <span @click="cur=0;jumpTo()" :class="{active_table:cur=0}">作业安排</span>
        </div>
        <div class="head_title_font class_head_title_font" style="margin-left: 20px">
          <span @click="cur=1;jumpToScore()" :class="{active_table:cur=1}">作业成绩</span>
        </div>
      </div>-->
      <!--<div v-if="classStatus =='-1'" class="head_title class_head_title" style="border-bottom: 2px black solid;">
        <div class="head_title_font class_head_title_font">
          作业成绩
        </div>
      </div>-->

      <div class="class_body_content">
        <div class="class_body_content_self">
          <button type="button" class="btn btn-default btn_option"
                  style="height: 25px;line-height: 10px;margin-bottom: 5px;"
                  @click="exportStudentScore()">导出</button>
          <!--<table class="table table-striped table-bordered allStuTab">
            <thead>
            <tr>
              <th width="5%">序号</th>
              <th width="30%">学员姓名</th>
              &lt;!&ndash;<th>优</th>
              <th>良</th>
              <th>及格</th>
              <th>不及格</th>&ndash;&gt;
              <th>作业名称</th>
              <th>总分</th>
              <th width="30%">平均分</th>
              <th width="10%">详情</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(studentWorkResultOne,index) in allStudentWorkResultList" :key="index">
              <td width="5%">{{index+1}}</td>
              <td width="30%">{{studentWorkResultOne.studentName}}</td>
              &lt;!&ndash;<td>{{studentWorkResultOne.optimal}}</td>
              <td>{{studentWorkResultOne.good}}</td>
              <td>{{studentWorkResultOne.passed}}</td>
              <td>{{studentWorkResultOne.unPassed}}</td>&ndash;&gt;
              <td width="30%">{{studentWorkResultOne.schoolWorkName}}</td>
              <td width="10%">{{studentWorkResultOne.score}}</td>
              <td width="30%">{{studentWorkResultOne.avgScore}}</td>
              <td width="10%">
                <div class="details_pic" data-toggle="modal" data-target="#myModal" @click="studentScoreAndRemarkData(studentWorkResultOne.studentId)" ></div>
              </td>
            </tr>
            </tbody>
          </table>-->
          <table class="table table-striped table-bordered allStuTab">
            <thead>
            <tr>
              <th width="5%">序号</th>
              <th width="10%">学员姓名</th>
              <th v-for="(workName,index) in homeWorkList">
                {{workName.name}}
              </th>
              <th width="4%">总分</th>
              <th width="5%">平均分</th>
              <th width="4%">详情</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(studentWorkResultOne,index) in allStudentWorkResultList" :key="index">
              <td width="5%">{{index+1}}</td>
              <td width="10%">{{studentWorkResultOne.studentName}}</td>
              <td v-for="(workOne,index) in studentWorkResultOne.studentSchoolWorks">
                {{workOne.score}}
              </td>
              <td>{{studentWorkResultOne.score}}</td>
              <td>{{studentWorkResultOne.avgScore}}</td>
              <td>
                <div class="details_pic" data-toggle="modal" data-target="#myModal" @click="studentScoreAndRemarkData(studentWorkResultOne.id)" ></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 模态框（Modal） -->
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">{{studentWorks.schoolWorkName}}</h4>
          </div>
          <div class="modal-body">
            <table class="table table-striped table-bordered oneStuTab">
              <tbody>
              <tr>
                <th width="30%">党性修养考核</th>
                <th width="10%">评分</th>
                <th>评语</th>
              </tr>
              <tr v-if="studentScoreAndRemarkOne.type=='党性修养考核'" v-for="(studentScoreAndRemarkOne,index) in studentScoreAndRemarkList" :key="index">
                <td width="30%">{{studentScoreAndRemarkOne.schoolWorkName}}</td>
                <td width="10%">{{studentScoreAndRemarkOne.score}}</td>
                <td>{{studentScoreAndRemarkOne.remark}}</td>
              </tr>
              </tbody>
            </table>

            <table class="table table-striped table-bordered oneStuTab">
              <tbody>
              <tr>
                <th width="30%">知识能力考核</th>
                <th width="10%">评分</th>
                <th>评语</th>
              </tr>
              <tr v-if="studentScoreAndRemarkOne.type=='知识能力考核'" v-for="(studentScoreAndRemarkOne,index) in studentScoreAndRemarkList" :key="index">
                <td width="30%">{{studentScoreAndRemarkOne.schoolWorkName}}</td>
                <td width="10%">{{studentScoreAndRemarkOne.score}}</td>
                <td>{{studentScoreAndRemarkOne.remark}}</td>
              </tr>
              </tbody>
            </table>


            <table class="table table-striped table-bordered oneStuTab">
              <tbody>
              <tr>
                <th width="30%">调研课题</th>
                <th width="10%">评分</th>
                <th>评语</th>
              </tr>
              <tr v-if="studentScoreAndRemarkOne.type=='调研课题'" v-for="(studentScoreAndRemarkOne,index) in studentScoreAndRemarkList" :key="index">
                <td width="30%">{{studentScoreAndRemarkOne.schoolWorkName}}</td>
                <td width="10%">{{studentScoreAndRemarkOne.score}}</td>
                <td>{{studentScoreAndRemarkOne.remark}}</td>
              </tr>
              </tbody>
            </table>

            <table class="table table-striped table-bordered oneStuTab">
              <tbody>
              <tr>
                <th width="30%">结业论文</th>
                <th width="10%">评分</th>
                <th>评语</th>
              </tr>
              <tr v-if="studentScoreAndRemarkOne.type=='结业论文'" v-for="(studentScoreAndRemarkOne,index) in studentScoreAndRemarkList" :key="index">
                <td width="30%">{{studentScoreAndRemarkOne.schoolWorkName}}</td>
                <td width="10%">{{studentScoreAndRemarkOne.score}}</td>
                <td>{{studentScoreAndRemarkOne.remark}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>
  </div>
</template>

<script>
  import {getContentSize} from '../mainView';
  import {schoolAxios} from "../../main";
  import dictionaryData from '../../json/dictionary';

  export default {
    name: "homeworkScore",
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,

        homeWorkList:[],
        allStudentWorkResultList:[],
        oneData:[],

        studentScoreAndRemarkList:[],

        studentWorks:{
          type:'',
          studentId:'',
          schoolWorkName:'',
        },
        //作业安排与成绩切换flag
        cur:1, //默认选中第一个tab
        hrefExport:this.$store.state.serviceBase+"resources/",
      }
    },
    filters: {
      formatStudentScore(value){
        let this_ = this;
        if(dictionaryData.school_score && value){
          value = dictionaryData.school_score[value];
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        this_.studentWorkResultList();
        // this_.studentScoreAndRemarkData();
      });
    },
    methods: {
      /**
       * 加载所有学员的作业情况（优、良、及格、不及格的个数）
       */
      studentWorkResultList() {
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'studentSchoolwork/studentsWorkResultList',
          params: {
            "clazzId": this_.clazzId
            /*  "studentId":this_.allStudentWorkResultList.studentId,
            "type":this_.allStudentWorkResultList.type*/
            /*"type": this_.schoolWorkList_[this_.current_index].type*/
          }
        }).then(function (response) {
          let data = response.data;
          if (data.success) {
            this_.homeWorkList = data.list[0].schoolWorkName;
            this_.allStudentWorkResultList = data.list[1].studentSchoolWork;
            this_.allStudentWorkResultList.forEach(function (elem) {
              this_.oneData = elem.studentSchoolWorks;
              let total=0;
              let arr = [];
              let avgScore = 0;
              for(let i = 0;i<this_.oneData.length;i++){
                total+= Number(this_.oneData[i].score);
                elem.score = total;
                arr.push(Number(this_.oneData[i].score));
                avgScore = this_.avg.apply(null,arr);
                elem.avgScore = avgScore.toFixed(2);
              }
            })
          }
        });
      },

      avg() {
        let sum = 0;
        for (let i = 0, j = arguments.length; i < j; i++) {
          sum += arguments[i];
        }
        return sum / arguments.length;
      },
      //     alert(avg(2, 3, 4, 5)); // 3.5
      // // apply()方法可以重复调用改函数
      // alert(avg.apply(null,[2, 3, 4, 5]))



      /**
       * 加载单个学员所有类型所有作业评分、评语
       */
      studentScoreAndRemarkData(studentId) {
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'studentSchoolwork/studentScoreAndRemarkList',
          params: {
            "clazzId": this_.clazzId,
            /* "type": this_.studentWorks.type,*/
            "studentId": studentId
          }
        }).then(function (response) {
          console.info(response);
          let data = response.data;
          this_.studentScoreAndRemarkList = data.list;
        })
      },

      /**
       * 导出学员作业成绩
       */
      exportStudentScore(){
        let this_=this;
        schoolAxios({
          method: 'get',
          url:'studentSchoolwork/exportStudentsWorkResultList',
          params: {
            "clazzId":this_.clazzId,
          }
        }).then(function (response) {
          location.href=this_.hrefExport+response.data.data;
        });
      },

      /**
       * 作业安排作业成绩tab切换
       */
      jumpTo(){
        let this_ = this;
        if(this_.classStatus==0||this_.publishStatus==0){

          //路由跳转
          this_.$router.push({
            name: 'HomeworkArrange',
          });
        }else if(this_.classStatus==1 || this_.classStatus == -1){
          //路由跳转
          this_.$router.push({
            name: 'HomeworkManage',
          });

        }
      },
      jumpToScore(){
        let this_ = this;
        this_.$router.push({
          name: 'HomeworkScore',
        });
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/plugins.css';
  @import "../../assets/css/publicStyle.css";
  .head_title_font {
    border: none;
  }
  .class_head_title_font {
    width: 80px;
    cursor: pointer;
  }
  .body_content .class_body_content {
    top: 8%;
  }
  .active_table {
    /*background-color: #ff6f66;*/
    color: #ff6f66;
    padding-bottom: 8px;
    border-bottom: 3px solid #ff6f66;
  }
  .table {
    color: #FFFFFF;
  }
  .table th {
    color: #000000;
    background-color: #cccccc;
  }
  .table tr{
    color: black;
    background-color: #FFFFFF;
  }
  .table,.table th {
    text-align: center;
  }
  .class_body_content {
    top: 10%;
    height: 90%;
  }
  .details_pic {
    margin: auto;
    width: 29px;
    height: 22px;
    background-image: url("../../assets/img/right/teachingEvaluation/details_mouseOver.png");
    background-size: 100% 100%;
    cursor: pointer;
  }
  .details_pic:hover{
    background-image: url("../../assets/img/right/teachingEvaluation/details_mouseOver.png");
  }
  .modal-dialog {
    width: 65%;
  }
  /*.modal-content {
    height: 350px;
  }*/
  .modal-title {
    text-align: center;
  }
  .modal-body {
    text-align: center;
  }
  /*table th:first-child {
    width: 30%;
  }
  table td:first-child {
    width: 30%;
  }

  table th:nth-child(2) {
    width: 10%;
  }
  table td:nth-child(2) {
    width: 10%;
  }
  .allStuTab th:first-child {
    width: 5%;
  }
  .allStuTab td:first-child {
    width: 5%;
  }
  allStuTab th:nth-child(2) {
    width: 25%;
  }
  allStuTab td:nth-child(2) {
    width: 25%;
  }
  .allStuTab td{
    width: 10%;
  }*/
  .oneStuTab tbody{
    height: auto;
  }
  .allStuTab tbody{
    height: 510px;
  }

</style>



// WEBPACK FOOTER //
// src/components/teacherClass/homeworkScoreTea.vue